import React, {useContext, useEffect} from 'react';
import moment from 'moment';
import {connect} from 'react-redux';
import {
  Loader,
  Modal,
  PrimaryButton,
  SecondaryButton,
  TableLayout,
} from '../../../components';
import {capitalizeEveryWord} from '../../../helpers';
import {closeModal} from '../../../assets/images/images';
import * as Actions from '../../../store/actions';
import {PageContext} from '../../../helpers/context';

function BatchAmlResultModal({
  aml: {lookupLoading, loading},
  open,
  setOpen,
  selectedHistory,
  downloadAmlBatchLookup,
}) {
  const totalRecords = selectedHistory?.total_records || 0;
  const processedRecords = selectedHistory?.processed_records || 0;
  const {setPageName} = useContext(PageContext);
  useEffect(() => {
    setPageName('amllookup');
  }, [setPageName]);

  const percentage =
    totalRecords !== 0 ? (processedRecords / totalRecords) * 100 : 0;

  return (
    <Modal
      show={open}
      onClose={setOpen}
      extraModalClasses="max-w-[528px] overflow-y-auto h-fit max-h-[95%] sm:max-h-full rounded-b-none sm:rounded-b-lg absolute bottom-0 sm:relative lookup-modal"
      modalPosition="justify-center sm:justify-end"
      modalTitle={
        <div className="flex flex-wrap items-center gap-2">
          <h3 className="text-base font-medium text-grey">
            {capitalizeEveryWord(
              selectedHistory?.lookup_type?.replace('_', ' '),
            )}{' '}
            Verification
          </h3>
          <div className="px-2 py-1 text-xs font-medium uppercase rounded-full text-brandBlue50 bg-brandBlue40 w-fit">
            Batch upload
          </div>
          <div
            className={`px-2 py-1 text-xs font-medium uppercase rounded-full  w-fit ${
              percentage === 100
                ? 'text-success20 bg-success'
                : 'text-white bg-status-404'
            }`}
          >
            {percentage === 100 ? 'Successful' : 'Processing'}
          </div>
        </div>
      }
    >
      {loading ? (
        <Loader height={30} />
      ) : (
        <>
          <div className="p-6">
            <div
              className={`relative h-4 mb-8 text-xs font-medium ${
                percentage > 50 && 'text-white'
              }  rounded-full bg-brandBlue40`}
            >
              <span className="absolute left-0 right-0 top-1">
                {(!lookupLoading && percentage) || 0}%
              </span>
              <progress
                id="file"
                value={(!lookupLoading && percentage) || 0}
                max="100"
              ></progress>
            </div>

            {lookupLoading ? (
              <Loader height={30} />
            ) : (
              <TableLayout negativeMargins>
                <thead className="font-semibold uppercase">
                  <tr className="bg-white80">
                    <th className="pl-4 sm:pl-6 xl:pl-8 h-11 font-medium text-left text-small text-[#5C688E] whitespace-nowrap">
                      number of id
                    </th>
                    <th className="pl-0 font-medium text-left h-11 text-small text-[#5C688E] whitespace-nowrap">
                      ID type
                    </th>
                    <th className="pl-0 font-medium text-left h-11 text-small text-[#5C688E] whitespace-nowrap">
                      Last checked
                    </th>
                  </tr>
                </thead>
                <tbody className="text-left text-tiny">
                  <tr className="border-[0.5px] border-[#E4E3EC] cursor-pointer">
                    <td className="p-4 pl-4 sm:pl-6 xl:pl-8  text-body whitespace-nowrap">
                      {selectedHistory?.total_records}
                    </td>
                    <td className="p-4 pl-0  text-body whitespace-nowrap">
                      {selectedHistory?.lookup_type}
                    </td>
                    <td className="p-4 pl-0  text-body whitespace-nowrap">
                      {moment(selectedHistory?.date_updated).format(
                        'DD MMM YYYY HH:mm',
                      )}
                    </td>
                  </tr>
                </tbody>
              </TableLayout>
            )}
            {!lookupLoading && (
              <div className=" print:flex print:items-center print:justify-between text-xs text-body uppercase mt-8 mb-3 px-[5.88%]">
                <span>
                  Performed by:{' '}
                  {selectedHistory?.caller_name || selectedHistory?.caller_email
                    ? selectedHistory?.caller_name ||
                      selectedHistory?.caller_email
                    : '-'}
                </span>
                <span className="ml-8">
                  Generated:{' '}
                  {selectedHistory?.date_created
                    ? moment(selectedHistory?.date_created).format(
                        'MMM DD, YYYY hh:mmA',
                      )
                    : moment(new Date()).format('MMM DD, YYYY hh:mmA') || '-'}
                </span>
              </div>
            )}
          </div>
          <div className="w-full px-6 py-[14px] flex items-center gap-5 border-[0.5px] border-transparent border-t-[#EFEFEF]">
            <button className="flex items-center !md:w-[20%] justify-between sm:justify-start gap-4 py-[14px] px-4 text-tiny text-grey80 bg-white80 outline outline-1 outline-grey60 rounded !h-10 focus-visible:outline-brandBlue">
              XLSX
            </button>
            <PrimaryButton
              buttonText="Download"
              className="w-[80%] !h-10"
              onClick={() => {
                downloadAmlBatchLookup(selectedHistory?.id, () => {
                  setOpen(false);
                });
              }}
              loading={lookupLoading}
              disabled={lookupLoading || percentage !== 100}
            />
          </div>
        </>
      )}
    </Modal>
  );
}

export default connect(state => state, Actions)(BatchAmlResultModal);
